import { PrioritizationCriteriaSettingBase } from './base/prioritization-criteria-setting-base';

export class PrioritizationCriteriaSetting extends PrioritizationCriteriaSettingBase { }